import { render, staticRenderFns } from "./CustomerParticipantDetails.vue?vue&type=template&id=201a6470&scoped=true&"
import script from "./CustomerParticipantDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerParticipantDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomerParticipantDetails.vue?vue&type=style&index=0&id=201a6470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a6470",
  null
  
)

export default component.exports